(function ($) {

    // NOTE you will need markerclusterer version 2.1.11 to make the maps work
    // NOTE change acf-map class to acf-map2 to make this work
    // NOTE you will need CSS classes for acf-map2 or it won't show
    $(document).ready(function () 
    {

        if ( $( ".acf-map2" ).length ) 
        {

            var addedMarkers = []; 
            var userMarker;
            var mc; // clusterer
            var max_results = 25;

            function new_map2($el) 
            {
                var $markers = $el.find('.marker');
                var args = {
                    zoom: 6,
                    center: new google.maps.LatLng(0, 0),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e9e9e9"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 29
                                },
                                {
                                    "weight": 0.2
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#dedede"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#333333"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f2f2f2"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        }
                    ]
                };


                var map = new google.maps.Map($el[0], args);
                
                map.markers = [];
                $markers.each(function () 
                {
                    add_marker($(this), map);
                });
                
                addedMarkers = map.markers;
            
                center_map(map);
                current_window = null;
                add_cluster(map, map.markers);
                show_user_position(map);


                // we don't really need this function unless you want to lock people to a smaller zoom
                google.maps.event.addListener(map, 'zoom_changed', function() 
                { 
                    var zoomLevel = map.getZoom(); 
                    if (zoomLevel >= 20) 
                    { 
                        map.setZoom(20); 
                    } 
                }); 

                // this is purely for debugging and isn't needed
                google.maps.event.addListener(mc, 'clusteringend', function()
                {
                    //console.log("Map Rebuilt");
                });

                return map;
            }


            // this add_marker requires a custom pin
            function add_marker($marker, map) 
            {
                var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

                var signature = $marker.attr('data-signature');

                var image2 = '/app/themes/ba2019/img/layout/home-icon.png'

                if (signature && signature == "5")
                {
                    var image2 = '/app/themes/ba2019/img/layout/signature-icon.png'
                }

                var marker = new google.maps.Marker({
                    position: latlng,
                    map: map,
                    icon: image2,
                    id: $marker.attr('id'),
                });

                map.markers.push(marker);

                if ($marker.html()) 
                {

                    var infowindow = new google.maps.InfoWindow(
                    {
                        content: $marker.html(),
                        //disableAutoPan: true,
                    });

                    google.maps.event.addListener(marker, 'click', function () 
                    {
                        if(current_window != null) 
                        {
                            current_window.close(); 
                        }
                        infowindow.open(map, marker);
                        current_window = infowindow;
                    });
                }
            }

            // self explanatory, repositions map according to pins
            // but if we have a user pin, it become the center
            function center_map(map) 
            {

                var user_lat = getSimpleValue("user_set_lat");
                var user_lng = getSimpleValue("user_set_lng");

                if (!user_lat || user_lat == "" || user_lat === undefined)
                {
                    user_lat = getSimpleValue("user_lat");
                    user_lng = getSimpleValue("user_lng");
                }

                if (user_lng && user_lat)
                {
                    var myLatLng = new google.maps.LatLng(user_lat, user_lng);

                    map.setCenter(myLatLng);
                    var zoom = map.getZoom();
                    map.setZoom(zoom > 8 ? 6 : zoom);
                }
                else
                {
                    var lng_lats = [];
                    var bounds = new google.maps.LatLngBounds();
                    $.each(map.markers, function (i, marker) {
                        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                        lng_lats.push( [marker.position.lat(), marker.position.lng()]);
                        bounds.extend(latlng);
                    });

                    if (map.markers.length == 1) {
                        map.setCenter(bounds.getCenter());
                        map.setZoom(6);
                        // map.setZoom(16);
                    }
                    else {
                        //console.log( 'in the else');
                        map.setCenter(bounds.getCenter());
                        // map.fitBounds(bounds);
                        var zoom = map.getZoom();
                        map.setZoom(zoom > 8 ? 6 : zoom);
                    }
                }
            }

            // add clustering
            // note the use of ignoreHidden; essential for hide/show
            function add_cluster(map, markers)
            {
                mc = new MarkerClusterer(map, markers, 
                {
                    gridSize: 40, 
                    maxZoom: 20, 
                    zoomOnClick: true, 
                    minimumClusterSize: 4,
                    imagePath: "/app/themes/ba2019/img/layout/m/m",
                    ignoreHidden: true
                });
            }

            // show the user's position on the map
            // must be called after clustering, or clustering will kill it.
            function show_user_position(map) 
            {

                var user_lat = getSimpleValue("user_set_lat");
                var user_lng = getSimpleValue("user_set_lng");

                if (!user_lat || user_lat == "" || user_lat === undefined)
                {
                    user_lat = getSimpleValue("user_lat");
                    user_lng = getSimpleValue("user_lng");
                }
                var image = '/app/themes/ba2019/img/layout/user-icon.png';

                var marker_id = 'map_location_for_user';
                if (user_lng && user_lat)
                {
                    if (userMarker)
                    {
                        userMarker.setMap(null);
                        delete userMarker;
                    }
                    var myLatLng = new google.maps.LatLng(user_lat, user_lng);

                    userMarker = new google.maps.Marker({
                        position: myLatLng,
                        map: map,
                        icon: image,
                        id: marker_id,
                    });
                }

                return map;
            }


            // basically this interferes with Google's DOM object 
            // loops through its markers and changes visibility for each to true or false
            function toggleMarkers(haystack) 
            {

                var in_count = 0;
                var out_count = 0;

                for (i in addedMarkers) 
                {
                    var needle = addedMarkers[i].id;

                    var test = haystack.indexOf(needle);

                    var visibility = (test > -1) ? true : false;
                    if (visibility)
                    {
                        in_count++;
                    }
                    else
                    {
                        out_count++;
                    }
                    addedMarkers[i].setVisible(visibility);
                }

                mc.setIgnoreHidden(true); // just in case
                mc.repaint(); // now redraw the map
            }

            // sort divs A-Z
            function sortDivsAz()
            {
                var products = $('.retailer-list-item');
                products.sort(function(a, b)
                { 
                    if($(a).data("alphabet") < $(b) .data("alphabet")) { return -1; }
                    if($(b).data("alphabet") < $(a) .data("alphabet")) { return 1; }
                    return 0;
                });
                $("#all-listings").html(products);
            }
            // sort divs Z-A
            function sortDivsZa()
            {
                //console.log("za sort");
                var products = $('.retailer-list-item');
                products.sort(function(a, b)
                { 
                    if($(b).data("alphabet") < $(a).data("alphabet")) { return -1; }
                    if($(a).data("alphabet") < $(b).data("alphabet")) { return 1; }
                    return 0;
                });
                $("#all-listings").html(products);
            }

            // sort divs by Distance
            function sortDivsDistance()
            {
                var products = $('.retailer-list-item');
                products.sort(function(a, b){ return $(a).data("distance")-$(b).data("distance")});
                $("#all-listings").html(products);

            }


            // sort divs by Signature then Distance
            function sortDivsDefault()
            {
                var products = $('.retailer-list-item');

                products.sort(function(a, b) {
                    return $(b).data("signature")-$(a).data("signature")  ||  $(a).data("distance")-$(b).data("distance");
                });

                $("#all-listings").html(products);

            }

            // helper function to get the value of a node on the page
            function getSimpleValue( el )
            {
                var myInput = document.getElementById(el);
                if (myInput && myInput.innerHTML && myInput.innerHTML.length > 0) {
                  return myInput.innerHTML;
                }
                return false;
            }


        // on page load, load the map and detect if the sort order is clicked

            var geocoder = new google.maps.Geocoder();
            var timeout_address = null;

            $('.acf-map2').each(function () 
            {
                map = new_map2($(this));
            });

            $('.sort-button').on('click', function(e)
            {
                e.preventDefault();
                
                var sort_order = $(this).attr("data-ordering");
         
                $('.sort-button').each( function(i)
                {
                     $(this).removeClass("active");
                });  
                $(this).addClass("active"); 

                if (sort_order == "az")
                {
                    sortDivsAz();
                }
                if (sort_order == "za")
                {
                    sortDivsZa();
                }
                if (sort_order == "distance")
                {
                    sortDivsDistance();
                }
            });


            $("#set-geolocation").on('click', function(e) 
            {
                e.preventDefault();
                localStorage.removeItem('storedLocVars');
                getLocation();
                
                function getLocation() 
                {
                  if (navigator.geolocation) {
                      navigator.geolocation.getCurrentPosition(setPosition);
                  } 
                  else { 
                    alert("Geolocation is not supported by this browser.");
                  }
                }
                function setCookie(name,value,days) {
                    var expires = "";
                    if (days) {
                        var date = new Date();
                        date.setTime(date.getTime() + (days*24*60*60*1000));
                        expires = "; expires=" + date.toUTCString();
                    }
                    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
                }

                function setPosition(position) 
                {
                  var LatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
         
                  geocoder.geocode({'location': LatLng}, function(results, status) 
                  {
                    if (status === 'OK') {
                      if (results[0]) 
                      {
                        var city = "";
                        var area = "";
                        var postcode = "";
                        var country = "";

                        for (var ac = 0; ac < results[0].address_components.length; ac++) 
                        {
                            var component = results[0].address_components[ac];

                            switch(component.types[0]) {
                              case 'locality':  
                                city = component.short_name;
                                break;
                              case 'postal_town':  
                                city = component.short_name;
                                break;
                              case 'administrative_area_level_1':
                                area = component.short_name;
                                break;
                              case 'postal_code':
                                postcode = component.short_name;
                                break;
                              case 'country':
                                country = component.short_name;
                                break;

                            }
                        };

                        setCookie('userLocation_Lat', position.coords.latitude, 1, "/" );
                        setCookie('userLocation_Lng', position.coords.longitude, 1, "/" );
                        setCookie('userLocation_City', city, 1, "/" );
                        setCookie('userLocation_Area', area, 1, "/" );
                        setCookie('userLocation_Postcode', postcode, 1, "/" );

                        var url = window.location.href;    
                        window.location.href = url;


                      } 
                    } 
                  });
                }
            });

            // if the user presses enter when searching an address
            $('#search_address').keypress(function(event)
            {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if(keycode == '13')
                {
                    event.preventDefault();
                    clearTimeout(timeout_address);
                    timeout_address = setTimeout(function() 
                    {
                        manualLocation();
                    }, 1000);
                }
            });

            // if theyser presses the search address button
            $("#search_address_go").click(function(e) 
            {
                e.preventDefault();
                clearTimeout(timeout_address);
                timeout_address = setTimeout(function() 
                {
                    manualLocation();
                }, 1000);
            });

            // powerful function that hooks into Google GeoCode with a string, and returns 
            // an array of data that is then turned into strings and node data
            // then updates, clears cookies 
            // ultimately, calls buildAssociatedDate with what it finds
            function manualLocation()
            {

                var use_address = $("#search_address").val();
                var final_address = "";
                var final_string = "";

                geocoder.geocode( { 'address': use_address, 'region': 'EU' }, function(results, status) {

                  if (status == google.maps.GeocoderStatus.OK) 
                  {
                      localStorage.removeItem('storedMapPage')
                      var city = "";
                      var area = "";
                      var postcode = "";
                      var country = "";
                      
                      final_address = results[0].formatted_address;

                      /*if (final_address != "Scotland, UK") // make sure we don't return ", Scotland" as the location
                      {*/

                        for (var ac = 0; ac < results[0].address_components.length; ac++) 
                        {
                            var component = results[0].address_components[ac];
                            //console.log(component.types[0] + " " + component.short_name);
                            switch(component.types[0]) 
                            {
                              case 'locality':  
                                city = component.short_name;
                                break;
                              case 'postal_town':  
                                city = component.short_name;
                                break;
                              case 'administrative_area_level_1':
                                area = component.short_name;
                                break;
                              case 'postal_code':
                                postcode = component.short_name;
                                break;
                              case 'country':
                                country = component.short_name;
                                break;

                            }
                        };
                        var custom_lat = results[0].geometry.location.lat();
                        var custom_lng  = results[0].geometry.location.lng();

                        // update hidden fields
                        $("#user_set_lat").html(custom_lat); 
                        $("#user_set_lng").html(custom_lng);  

                        // change the user messages and reflow the data
                        final_string = "Your location has been set by you as: <b>" + final_address + "</b>.";
                        //$("#user-location-message").html(final_string);
                        buildAssociatedData();
                        show_user_position(map);
                        center_map(map);

                        var storedLocVars = 
                        {
                            final_string: final_string,
                            user_set_lng: custom_lng,
                            user_set_lat: custom_lat
                        }

                        localStorage.setItem('storedLocVars', JSON.stringify(storedLocVars));

                      /*}
                      else
                      {
                          final_string = "This location cannot be found. Please try again.";
                          //localStorage.removeItem('storedLocVars');
                      }*/
                  }

                  else
                  {
                      final_string = "This location cannot be found. Please try again."
                      //localStorage.removeItem('storedLocVars');
                  }
                  $('#location-input-info').html(final_string);

              });

                
            }

            // there are quite a few nodes on the page that need to be updated on changes
            // this handles all of those
            function buildAssociatedData()
            {
                var user_lat = getSimpleValue("user_set_lat");
                var user_lng = getSimpleValue("user_set_lng");

                if (!user_lat || user_lat == "" || user_lat === undefined)
                {
                    user_lat = getSimpleValue("user_lat");
                    user_lng = getSimpleValue("user_lng");
                }

                if (user_lng && user_lat)
                {
                    len = $(".distance-to").length;

                    $(".distance-to").each(function(i, obj)
                    {
                        var lat = $(this).data('lat'); 
                        var lng = $(this).data('lng'); 
                        var distance = getDistanceBetween(user_lat, user_lng, lat, lng);
                        $(this).html("(" + distance + " miles)");
                        $(this).closest("div.retailer-list-item").attr("data-distance", distance); 

                    });
                    sortDivsDistance();
                    sortDivsDefault();
                    applyFilters();
                }
            }

            function applyFilters()
            {

                var radiusValue = parseInt($('input[type=radio][name="distance_filter"]:checked').val());
                if (isNaN(radiusValue))
                {   
                    radiusValue = 50;
                }
                var kitchenValue = ( $('#kitchens_filter').is(':checked') ) ? true : false;
                var bedroomValue = ( $('#bedrooms_filter').is(':checked') ) ? true : false;
                var doorValue = ( $('#door_filter').is(':checked') ) ? true : false;

                //console.log(radiusValue, kitchenValue, bedroomValue, showroomValue);

                //var max_results = 20; //$( "#max_results" ).val();
                var active_ids = [];

                // first hide them all
                $('.retailer-list-item').each(function(i, obj)
                {
                    $(this).attr("data-current-index", i);
                    $(this).fadeOut(300);
                });
                setTimeout( showActive, 300 );

                function showActive()
                {
                    var remaining = max_results;

                    // return those inside the current limit
                    $('.retailer-list-item').each(function(i, obj)
                    {

                        if (remaining > 0)
                        {

                            showItem = 0;
                            dataDistance = parseInt($(this).data('distance'));

                            if(dataDistance <= radiusValue)
                            {
                                showItem++;
                            }

                            if(!kitchenValue || (kitchenValue && $(this).data('category').includes('kitchens')))
                            {
                                showItem++;
                            }

                            if(!bedroomValue || (bedroomValue && $(this).data('category').includes('bedrooms')))
                            {
                                showItem++;
                            }

                            if(!doorValue || (doorValue && $(this).data('category').includes('door-replacements')))
                            {
                                showItem++;
                            }

                            //console.log($(this).data('sibling-card'), showItem, remaining);
                            if(showItem == 4)
                            {
                                var sibling_card = $(this).data('sibling-card');
                                active_ids.push(sibling_card); 
                                $(this).fadeIn(300); 
                                remaining = remaining - 1 ;
                            }
                        }
                    });
                    //console.log(active_ids);
                    $('#page-counter-results').text(active_ids.length);

                    if (active_ids.length > 0)
                    {
                        $("#no-results").addClass("d-none");
                        $("#retailers-sort").removeClass("d-none");
                        
                    }
                    else
                    {
                        $("#no-results").removeClass("d-none");   
                        $("#retailers-sort").addClass("d-none");
                    }

                        

                    toggleMarkers(active_ids);
                }

            }

            $( ".do-location-filter-checkbox, .do-location-filter-radio" ).change(function() 
            {
                applyFilters();
            });


            $("#set-location-button").on('click', function(e)
            {
                e.preventDefault();
                $(this).toggleClass("active");
                if ($(this).hasClass("active"))
                {
                    $('#set-location-options').addClass("show-me");
                    $(this).html("Close Location Options");
                
                }
                else
                {
                    $('#set-location-options').removeClass("show-me");
                    $(this).html("Set your Location");
                }
            });
            // helper function that calculates distance between two sets of coordinates
            // can return metric or imperial
            function getDistanceBetween(lat1, lon1, lat2, lon2, unit) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                }
                else {
                    var radlat1 = Math.PI * lat1/180;
                    var radlat2 = Math.PI * lat2/180;
                    var theta = lon1-lon2;
                    var radtheta = Math.PI * theta/180;
                    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180/Math.PI;
                    dist = dist * 60 * 1.1515;
                    if (unit=="K") { dist = dist * 1.609344 }
                    if (unit=="N") { dist = dist * 0.8684 }

                    if (dist < 10)
                    {
                        return roundPoint2(dist, 2);
                    }
                    else
                    {
                        return roundPoint2(dist, 0);
                    }
                }
            }

            // helper function for decimal places
            function roundPoint2 (_n,d) {
                return (Math.round (_n*Math.pow(10,d)))/Math.pow(10,d);
            }

            buildAssociatedData(); // hopefully this kicks in after page load, basically adds filters from the off

        }// if acfmap2     

    });


})(jQuery);